import { Log } from '../../AuxillaryService/Log';

/**
 * Attempts to fetch the ETag and Last-Modified headers from a target URL.
 */
export async function tryFetchMetadata(
    url: string
): Promise<{ etag: string | null; lastModified: string | null }> {
    try {
        Log.Debug(
            `Attempting to fetch ETag and Last-Modified headers from '${url}' using HEAD request`,
            null,
            __fileline
        );

        const response = await fetch(url, { method: 'HEAD' });

        if (response.ok) {
            return {
                etag: response.headers.get('etag'),
                lastModified: response.headers.get('last-modified'),
            };
        } else {
            throw new Error(`Request failed with status ${response.status}`);
        }
    } catch (err) {
        Log.Warning(
            `failed to fetch Etag and Last-Modified from '${url}' using HEAD request`,
            null,
            __fileline
        );
    }

    return {
        etag: null,
        lastModified: null,
    };
}
